'use client';
import React, { useRef, useState } from 'react';

import { useDialogs } from '~entities/dialogs';
import { useNavigationLinks } from '~hooks/useNavigationLinks';
import ArrowIcon from '~public/assets/icons/navigation/arrow.svg';
import { CounterBadge } from '~shared/ui/atoms';
import { ButtonGhost } from '~shared/ui/molecules';

import { MenuDropdown } from '../MenuDropdown';
import { ArrowIconContainer } from '../styles';

export const MenuContent = () => {
	const links = useNavigationLinks();
	const { unreadMessagesCount } = useDialogs();

	const dropdownRef = useRef<HTMLButtonElement | null>(null);
	const [dropdownOpen, setDropdownOpen] = useState(false);

	return (
		<>
			{links.map((link) =>
				'children' in link ? (
					<React.Fragment key={link.text}>
						<ButtonGhost
							size="M"
							data-name={link['data-name']}
							type="button"
							ref={dropdownRef}
							selected={link.active}
							onClick={link.handle}
							rightIcon={
								<ArrowIconContainer active={dropdownOpen}>
									<ArrowIcon />
								</ArrowIconContainer>
							}
						>
							{link.text}
						</ButtonGhost>
						<MenuDropdown
							mode="hover"
							items={link.children}
							targetRef={dropdownRef}
							onChange={setDropdownOpen}
						/>
					</React.Fragment>
				) : (
					<ButtonGhost
						data-name={link['data-name']}
						key={link.path}
						size="M"
						selected={link.active}
						disabledIconStyles={true}
						rightIcon={
							link.withMessageCounter && !!unreadMessagesCount ? (
								<CounterBadge count={unreadMessagesCount} />
							) : undefined
						}
						href={link.active ? undefined : link.path}
						onClick={link.handle}
					>
						{link.text}
					</ButtonGhost>
				)
			)}
		</>
	);
};
